module.exports = __webpack_public_path__ + "img/空白头像@2x.ff87f417.png";